import logo from "../assets/images/logo.png"
import logo_c from "../assets/images/company_logo.png"
export default {
    home: {
        welcome1: '관찰자',
        welcome2: '도서관',
        logo,
        lang: [
            {
                title: '繁體中文',
                key: 'zh-tw'
            },
            {
                title: '简体中文',
                key: 'zh-cn'
            },
            {
                title: 'English',
                key: 'en'
            },
            {
                title: '日本語',
                key: 'ja'
            },
            {
                title: '한국어',
                key: 'ko'
            }
        ],
        reward: "전용 보상",
        welfare: "한정 특전",
        up: "이벤트 설명",
        activity: {
            time: {
                title: "이벤트 기간:",
                year_start: "2019년 ",
                year_end: "2020년 ",
                month_day_start: "11월 21일 ",
                month_day_end: "2월 3일 11:00AM",
            }, 
            content: {
                title: "이벤트 방법: ",
                way: [
                    `1. [보상 받기]를 누르고 <스도리카> X <검볼앤던전(G&D)> 콜라보 전용 보상을 받아보세요`,
                    `2. [한정 특전]을 누르고 콜라보 이벤트 웹페이지로 들어가 더 많은 특전을 누려보세요.`,
                    `3. 본 웹페이지에서는 콜라보 이벤트 중 <스도리카> 전용 보상만을 수령하실 수 있습니다.`,
                    `4. <검볼앤던전(G&D)> 전용 보상을 수령하고자 하시는 유저분들께서는 <검볼앤던전(G&D)> 이벤트 웹페이지로 이동해주시기 바랍니다.`,
                    `5. 매 SID 서버 별 계정 하나 당 1개의 전용 보상을 수령하실 수 있습니다. 전용 보상은 등록하셨던 서버 계정에서 제공됩니다.`,
                    `6. 전용 보상은 게임 내 메일함을 통해 수령하실 수 있으며, 수령 유효기간은 30일입니다. 수령하신 후 전용 보상을 제대로 수령하셨는지 확인해주세요.`]
            }
        }
    },
    welfare: {
        back: "홈으로 이동",
        welcome1: '관찰자',
        welcome2: '도서관',
        gumballs_activity: {
            time: {
                title: "이벤트 기간: ",
                year_start: "2019년 ",
                year_end: "2020년 ",
                month_day_start: "11월 21일 ",
                month_day_end: "2월 3일 11:00AM",
            },
            content: {
                title: "이벤트 방법:",
                way: [
                    `1. [<검볼앤던전(G&D)> 이벤트 리딤코드 받기]를 누르고 <검볼앤던전(G&D)> 콜라보 이벤트 한정 리딤코드를 받아보세요.`,
                    `2. [<검볼앤던전(G&D)> 다운로드]를 누르고 <검볼앤던전>을 설치해주세요.`,
                    `3. <검볼앤던전(G&D)> 우측 상단의 톱니바퀴를 클릭하여 비밀지령을 교환하세요`
                ]
            },
            get_code: "<검볼앤던전(G&D)> 이벤트 리딤코드 받기",
            download: "<검볼앤던전(G&D)> 다운로드"
        },
        sdorica_activity: {
            time: {
                title: "이벤트 기간:",
                year_start: "2019년 ",
                year_end: "2020년 ",
                month_day_start: "11월 21일",
                month_day_end: "2월 3일 11:00AM",
            },
            content: {
                title: "이벤트 방법:",
                way: [
                    `1. <검볼앤던전(G&D)> 콜라보 이벤트 웹페이지에서 <스도리카> 콜라보 이벤트 한정 리딤코드를 받아보세요.`,
                    `2. 아래의 코드 입력창에 리딤코드를 입력하고 '수령하기'를 눌러주세요.`,
                    `3. 매 SID 서버 별 계정 하나 당 1개의 전용 보상을 수령하실 수 있습니다.`,
                    `4. 서버명 및 닉네임을 다시 한 번 확인한 후 수령해주세요. 리딤코드는 한 번만 사용하실 수 있습니다.`,
                    `5. 전용 보상은 게임 내 메일함을 통해 수령하실 수 있으며, 수령 유효기간은 30일입니다. 수령하신 후 전용 보상을 제대로 수령하셨는지 확인해주세요.`
                ]
            },
            label: "이벤트 리딤코드:",
            placeholder: "터치하고 이벤트 리딤코드 입력하기",
            noEnter_placeholder: "이벤트 리딤코드를 입력해주세요.",
            get_welfare: "<스도리카> 한정 특전 받기",
            got_welfare: "선물을 받았습니다!"
        }
    },
    get_reward: {
        done: {
            title: "수령 성공!",
            content: ["전용 보상이 게임 내 메일함으로 전송되었습니다.", "게임에서 확인해주세요."]
        },
        failed: {
            title: "수령 실패!",
            retry:"다시 시도하기"
        }
    },
    code_config: {
        title: "<검볼앤던전(G&D)> 한정 이벤트 리딤코드",
        copy: "복사하기",
        download: "<검볼앤던전(G&D)> 다운로드 후 이벤트 페이지에서 사용하기",
        success: '복사 성공'

    },
    rightCode: '정확한 이벤트 리딤코드를 입력해주세요.',
    messageFailed: "이미 받으셨습니다.",
    footer: {
        logo: logo_c,
        company: "© 2019 Rayark Inc. All rights reserved.",
        caseNumber: "",
        copyright: "",
        publicSecurityRecordNumber: "",
        wangwen: ""

    },
    resize: '휴대폰/패드를 조정해주세요.',
    notFound: '죄송합니다. 찾으시는 페이지가 존재하지 않습니다.',
    network_error: {
        INVALID_REWARD_TYPE: '유효하지 않은 보상',
        EXIST_REWARD_RECORD: '보상을 수령하셨습니다.',
        INVALID_CODE: '리딤코드 인증 실패',
        CODE_USED: '이미 사용된 리딤코드입니다.',
        GAMEDATA_INVALID_VALUE: '수령 실패',
        OTHER:'수령 실패',
        NO_TOKEN:'본 이벤트는 게임 내 이벤트 화면을 터치하시고 진행하실 수 있습니다.'
    }

}